export const routePaths = Object.freeze({
  HOME: 'home',
  LOGIN: 'login',
  DASHBOARD: 'dashboard',
  CAM: 'cam',
  QR: 'qr',
})
